// Import Libraries
import React, { Component } from 'react';
import FocusTrap from 'focus-trap-react';
import PropTypes from 'prop-types';
import translate from '../../_utils/tools/translate';
import { builderDispatch, WebUI } from '../../_utils/ui';
import { DeliveryOption, PrintFinish, PrintSize } from '../prop-types';
import PricesTable from '../../_grouped-category/prices-table';
import { pricingTableData } from './_pricing-chart-popup';

class PricingChartPopup extends Component {
  static isSquare(product) {
    const matches = product.title.match(/[\d.]+/g) || [];
    if (matches.length !== 2) {
      return false;
    }

    const [x, y] = matches;
    return x === y;
  }

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.pricingChartModal = null;
  }

  UNSAFE_componentWillMount() {
    this.builderDispatchToken = builderDispatch.register(payload => {
      if (payload.type === WebUI.SHOW_PRINTS_PRICES) {
        console.log('payload ->>>', payload);
        this.open();
      }
    });
  }

  componentDidMount() {
    console.log('mounted -')
    $(this.pricingChartModal)
      .modal({ show: false })
      .on('hide.bs.modal', () => {
        this.setState({ isOpen: false });
      })
      .on('shown.bs.modal', () => {
        this.setState({ isOpen: true });
      });
  }

  componentWillUnmount() {
    builderDispatch.unregister(this.builderDispatchToken);
  }

  open() {
    console.log('open');
    $(this.pricingChartModal).modal({ show: true });
  }

  close() {
    $(this.pricingChartModal).modal('hide');
  }

  generateFinishesForDeliveryOptions() {
    const { products, deliveryOptions } = this.props;

    const finishesForDeliveryOptions = {};

    products.forEach(product => {
      const option = product.options;
      option.delivery_options.forEach(deliveryOption => {
        const availableDeliveryOption = deliveryOptions.find(
          delOpt => delOpt.key === deliveryOption
        );
        if (!availableDeliveryOption) return;

        const { code } = availableDeliveryOption;

        if (!finishesForDeliveryOptions[code]) {
          finishesForDeliveryOptions[code] = [];
        }

        if (
          finishesForDeliveryOptions[code].indexOf(option.finish.name) === -1
        ) {
          finishesForDeliveryOptions[code].push(option.finish.name);
        }
      });
    });

    return finishesForDeliveryOptions;
  }

  printFinishDescription(finishesForDeliveryOption) {
    const { finishes } = this.props;

    const finishTitles = (finishesForDeliveryOption || []).map(
      value => finishes.find(finish => finish.name === value).title
    );

    return finishTitles.length === 1
      ? `${finishTitles[0]} Only`
      : finishTitles.join(' or ');
  }

  deliveryDescriptionForCode(code, finishesForDeliveryOption) {
    const { deliveryOptions } = this.props;
    const deliveryOption = deliveryOptions.find(o => o.code === code);

    return (
      (deliveryOption && deliveryOption.help_text) ||
      this.printFinishDescription(finishesForDeliveryOption[code])
    );
  }

  render() {
    const products = pricingTableData(this.props.products);
    const oblongPrints = products.filter(
      product => !PricingChartPopup.isSquare(product)
    );
    const squarePrints = products.filter(PricingChartPopup.isSquare);
    const finishesForDeliveryOptions = this.generateFinishesForDeliveryOptions();
    const { isOpen } = this.state;
    const { deliveryOptions } = this.props;

    return (
      <FocusTrap active={isOpen}>
        <div
          ref={el => {
            this.pricingChartModal = el;
          }}
          className="modal pricing-chart-popup">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-heading">
                <h4 className="modal-title">Pricing Chart</h4>
                <button
                  aria-label="Close"
                  className="close"
                  data-dismiss="modal"
                  type="button"
                />
              </div>
              <div className="modal-body p-0">
                <PricesTable
                  products={[...oblongPrints, ...squarePrints]}
                  delivery_options={deliveryOptions}
                  deliveryTitleRA={`${translate('Pickup')} in 1-Hour`}
                  deliveryDescriptionRA={this.deliveryDescriptionForCode(
                    'RA',
                    finishesForDeliveryOptions
                  )}
                  deliveryDescriptionUFC={this.deliveryDescriptionForCode(
                    'UFC',
                    finishesForDeliveryOptions
                  )}
                  showBorders
                />
              </div>
            </div>
          </div>
        </div>
      </FocusTrap>
    );
  }
}

PricingChartPopup.propTypes = {
  deliveryOptions: DeliveryOption,
  finishes: PropTypes.arrayOf(PrintFinish),
  products: PropTypes.arrayOf(PrintSize),
}.isRequired;

export default PricingChartPopup;
